var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4444 3.11111H2.33333C1.90378 3.11111 1.55556 2.76289 1.55556 2.33333C1.55556 1.90378 1.90378 1.55556 2.33333 1.55556H12.4444C12.4444 0.696446 11.748 0 10.8889 0H2.33333C1.04467 0 0 1.04467 0 2.33333V12.4444C0 13.3036 0.696446 14 1.55556 14H12.4444C13.3036 14 14 13.3036 14 12.4444V4.66667C14 3.80756 13.3036 3.11111 12.4444 3.11111ZM12.4444 10.8889H6.99999C6.57044 10.8889 6.22221 10.5407 6.22221 10.1112V7.00006C6.22221 6.5705 6.57044 6.22228 6.99999 6.22228H12.4444V10.8889ZM8.94445 9.33327H8.16667C7.9519 9.33327 7.77779 9.15916 7.77779 8.94439V8.16661C7.77779 7.95183 7.9519 7.77772 8.16667 7.77772H8.94445C9.15923 7.77772 9.33334 7.95183 9.33334 8.16661V8.94439C9.33334 9.15916 9.15923 9.33327 8.94445 9.33327Z",
    fill: "#05C1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonate);
export default __webpack_public_path__ + "static/media/donate.c7384914.svg";
export { ForwardRef as ReactComponent };